<template>
  <router-view></router-view>
</template>
<style lang="scss">
  .btn-container--new {
    text-align: right;
    padding: 15px 15px * 2;
  }

  .center-container {
    align-items: center;
    justify-content: center;
    text-align: center;
    margin: 15px auto;
  }
</style>
<script>
export default {
  created () {

  },
}
</script>



// WEBPACK FOOTER //
// src/App.vue